import { render, staticRenderFns } from "./viewmarks.vue?vue&type=template&id=906d682c&"
import script from "./viewmarks.vue?vue&type=script&lang=js&"
export * from "./viewmarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports